import HierarchicalPaymentCodes from './hierarchical-payment-codes-component';
import HierarchicalPaymentCodesService from './hierarchical-payment-codes-service';
import HierarchicalPaymentCodeValidator from './hierarchical-payment-code-validator';

import './hierarchical-payment-codes.scss';

const MODULE_NAME = 'hierarchical-payment-codes';
const module = angular.module(MODULE_NAME, [])
    .directive(HierarchicalPaymentCodes.DIRECTIVE_NAME, HierarchicalPaymentCodes)
    .directive(HierarchicalPaymentCodeValidator.DIRECTIVE_NAME, HierarchicalPaymentCodeValidator)
    .service('hierarchicalPaymentCodesService', HierarchicalPaymentCodesService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-list/hierarchical-payment-codes/hierarchical-payment-codes-module.js